import { render, staticRenderFns } from "./UserFieldEdit.vue?vue&type=template&id=35f5d9fc&"
import script from "./UserFieldEdit.vue?vue&type=script&lang=js&"
export * from "./UserFieldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports